<button [type]="type" class="custom-btn border-0" [ngClass]="customClasses" [disabled]="disabled" [routerLink]="link">
    <ng-container *ngIf="iconPosition === 'start'">
        <i *ngIf="icon" [ngClass]="icon" class="me-1"></i>
    </ng-container>
    {{ label }}
    <ng-container *ngIf="iconPosition === 'end'">
        <i *ngIf="icon" [ngClass]="icon" class="ms-1"></i>
    </ng-container>
</button>